import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sidebarShow: true,
};

const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    set: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { set } = settingsSlice.actions;

// ✅ THIS is your reducer (default export)
export default settingsSlice.reducer;